import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Textarea } from "../components/ui/textarea";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";
import { formatApiError } from "../lib/format";
import { DIVISIONS } from "../lib/constants";

const empty = { name: "", whatsapp: "", email: "", password: "", requested_division_id: "", requested_role: "", notes: "" };

export default function Register() {
  const [f, setF] = useState(empty);
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      await api.post("/register", f);
      toast.success("Pendaftaran diterima. Menunggu verifikasi Owner.");
      nav("/login");
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen grid lg:grid-cols-2 app-bg">
      <div className="hidden lg:flex flex-col justify-between p-12 sidebar-bg text-white">
        <div className="flex items-center gap-3">
          <img src="/brand/dwos-logo-light.png" alt="DWOS"
            className="w-[120px] h-auto object-contain select-none" draggable={false}/>
          <div className="text-xs text-zinc-400 border-l border-zinc-700 pl-3">Pendaftaran Karyawan</div>
        </div>
        <div>
          <h1 className="font-display text-4xl font-semibold leading-tight max-w-md">Bergabung dengan tim Dessy Wedding Group.</h1>
          <p className="mt-4 text-zinc-300 max-w-md text-sm">Pilih divisi dan peran yang diinginkan. Owner akan meninjau dan memverifikasi akun Anda sebelum akses diberikan.</p>
        </div>
        <div className="text-xs text-zinc-500">© {new Date().getFullYear()} DWOS · Dessy Wedding OS</div>
      </div>
      <div className="flex items-center justify-center p-6">
        <div className="w-full max-w-md">
          <h2 className="font-display text-2xl font-semibold">Daftar Akun Karyawan</h2>
          <p className="text-sm text-[#5C6066] mt-1">Isi data berikut untuk pengajuan akun.</p>
          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="register-form">
            <div><Label>Nama Lengkap</Label><Input required className="mt-1.5 h-11 bg-white" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="reg-name" /></div>
            <div><Label>WhatsApp</Label><Input required className="mt-1.5 h-11 bg-white" value={f.whatsapp} onChange={(e) => setF({ ...f, whatsapp: e.target.value })} placeholder="+62..." data-testid="reg-whatsapp" /></div>
            <div><Label>Email</Label><Input required type="email" className="mt-1.5 h-11 bg-white" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="reg-email" /></div>
            <div><Label>Kata Sandi (min. 6 karakter)</Label><Input required type="password" className="mt-1.5 h-11 bg-white" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="reg-password" /></div>
            <div><Label>Divisi yang Diinginkan</Label>
              <Select value={f.requested_division_id} onValueChange={(v) => setF({ ...f, requested_division_id: v })}>
                <SelectTrigger className="mt-1.5 h-11 bg-white" data-testid="reg-division"><SelectValue placeholder="Pilih divisi" /></SelectTrigger>
                <SelectContent>{DIVISIONS.map((d) => <SelectItem key={d.id} value={d.id}>{d.name}</SelectItem>)}</SelectContent>
              </Select>
            </div>
            <div><Label>Posisi yang Diinginkan</Label><Input className="mt-1.5 h-11 bg-white" value={f.requested_role} onChange={(e) => setF({ ...f, requested_role: e.target.value })} placeholder="Contoh: Staf, Manager, Fotografer" data-testid="reg-role" /></div>
            <div><Label>Catatan (opsional)</Label><Textarea rows={2} className="mt-1.5" value={f.notes} onChange={(e) => setF({ ...f, notes: e.target.value })} /></div>
            <Button type="submit" disabled={busy} data-testid="reg-submit" className="w-full h-11 bg-brand text-white">{busy ? "Memproses..." : "Kirim Pengajuan"}</Button>
          </form>
          <div className="mt-4 text-xs text-center text-[#8C9096]">
            Sudah punya akun? <Link to="/login" className="text-brand">Masuk</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
